<!-- Mobiscroll acts weird when passing in an empty arrty for [valid] To get around this,
if there are no valid slots, we change the min and max dates to today so all dates are disabled -->

<div class="d-flex flex-column">
    <!-- Need to set different widths on the mobiscroll calendar for desktop, tablet preview, tablet hosted, and mobile -->
    <div class="d-flex align-items-center justify-content-center" [ngClass]="{'scss-slot-picker-desktop': isDesktop, 'scss-slot-picker-mobile': isMobile, 'scss-slot-picker-tablet': (!isViewOnly && isTablet),
        'scss-slot-picker-tablet-preview': (isViewOnly && isTablet), 'scss-slot-picker-empty': !validSlots.length, 'scss-slot-picker-timezone-override': timeZones.length > 0}">
        <mbsc-datepicker #datePicker
            [controls]="['calendar', 'timegrid']"
            display="inline"
            (click)="$event.stopPropagation()"
            (change)="$event.stopPropagation()"
            [min]="minDateJS"
            [max]="maxDateJS"
            [selectMultiple]="false"
            [stepMinute]="1"
            [labels]="labels"
            [valid]="validSlots.length ? validSlots : []"
            [dayNamesShort]="localeInfo.AbbreviatedDayNames"
            [monthNames]="localeInfo.MonthNames"
            [monthNamesShort]="localeInfo.AbbreviatedMonthNames"
            [dayNamesMin]="localeInfo.AbbreviatedDayNames"
            [pmText]="localeInfo.PMDesignator!"
            [amText]="localeInfo.AMDesignator!"
            [timeFormat]="timeFormat"
            [rtl]="localeInfo.RightToLeft"
            theme="ios"
            themeVariant="light"
            returnFormat="jsdate"
            (onChange)="DateChangeEvent($event)"
            (onPageLoading)="PageLoading($event)"
            [firstDay]="firstDayOfWeek"
            [dateFormat]="dateFormat | uppercase"
            [touchUi]="isMobile">
        </mbsc-datepicker>
        <!-- Empty State on Time Grid -->
        @if (currentDate.ToISO() | method: IsDateInvalid) {
            @if (!validSlots.length) {
                <div class="d-flex align-items-center flex-column justify-content-center scss-slot-picker-empty-state gap-2 h-100">
                    <lib-icon class="neutral-600" [icon]="Icon.Calendar.CalendarCancel" [size]="IconSize.Medium"></lib-icon>
                    <p class="typography-body-small neutral-600 text-center" i18n="@@CommonSlotPickerEmptyStateText">No time slots for this date</p>
                </div>
            }
        }

    </div>
    @if (timeZones.length > 0 && currentTimezone) {
        <div class="scss-slot-picker-timezone-picker d-flex justify-content-center">
            <lib-chip-button-select
                [stretch]="true"
                [disableBorder]="true"
                [disableBottomSheet]="true"
                [currentSelection]="currentTimezone.ID!"
                (selectionChange)="TimezoneChange($event!, true)">
                <ng-template #triggerTemplate let-item>
                    @if (GetCurrentSelectionByID(item); as chipData) {
                        <div class="d-flex gap-1 align-items-center text-truncate">
                            <p class="typography-label-large base-300 px-1 text-truncate">{{ chipData?.DisplayName}}</p>
                        </div>
                        }
                </ng-template>
                <ng-container *ngFor="let item of timeZones; let index = index">
                    <lib-chip-button-select-item [value]="item.ID">
                        {{item?.DisplayName}}
                    </lib-chip-button-select-item>
                </ng-container>
            </lib-chip-button-select>

        </div>
    }
</div>